<template>
  <div id="simple-layout">
    <div class="container cust-no-master" v-if="!displayContentBasedOnLoginBySSOValue">
      <header>
        <div id="divHeader">
          <div class="row text-center">
            <img id="imgLogo" :src="getHeaderImageUrl" alt="Header Logo" />
          </div>
        </div>
      </header>    

      <main>
        <div class="row simple-layout-content">
          <router-view />
        </div>
      </main>  

      <footer>
        <div id="footer">
          <Footer></Footer>
        </div>
      </footer>
    </div>
    <div class="container cust-no-master text-center" v-else>
      <div class="simple-layout-content">
        <label class="session-message">
          <v-icon name="times" class="icon-red" />&nbsp;&nbsp;<label class="display-inline" v-html="getSessionEndedMessageForSSOCustomer" />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import Footer from '@/components/common/Footer';

  export default {
    name: 'SimpleLayout',
    components: {
      Footer
    },
    mounted() {
      // Reset Authenticated flag back to false
      this.$store.commit('setAuthentication', false);
      this.$store.commit('setCurrentPageLayout', this.$LayoutType.SimpleLayout);
    },
    computed: {
      getHeaderImageUrl() {
        return this.$store.getters.getHeaderImage;
      },
      displayContentBasedOnLoginBySSOValue() {
        if (this.$route.meta.disableSSO === false) {
          return false;
        } else {
          return this.$store.getters.getCustomerLoginBySSOOnly;
        }
      },
      getSessionEndedMessageForSSOCustomer() {
       return this.$store.getters.getSessionEndedMessageForSSOCustomer;
     }
    }
  }
</script>

<style>
  @import url('../assets/css/no-master.css');

  .session-message {
    font-weight: bold;
    border: 1px solid #ececec;
    color: #737373;
    padding: 20px;
    width: 95%;
    margin: 20px auto;
    background: none;
    border-radius: 3px;
  }

  .icon-red {
    color: #71001c;
    vertical-align: middle;
  }

  .toasted a, .toasted a:hover {
    font-weight: normal;
    color: #ffffff;
  }

  .display-inline {
    display: inline;
  }
</style>
